
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-exhibitions",
      function () {
        return require("private-next-pages/news-exhibitions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-exhibitions"])
      });
    }
  